import { getShopIdFromLocation } from 'util/appUtils';

const shopPath = shopId => `/system/shop/${encodeURIComponent(shopId)}`;

/** Non-tracking catalog lookup used by shared admin product pickers in cloud. */
export function createLegacyProductSelectorApi({ client, shopId } = {}) {
  let resolvedClient = client || null;
  const getClient = () => {
    if (!resolvedClient) {
      // eslint-disable-next-line global-require
      resolvedClient = require('util/appUtils').wsClient;
    }
    return resolvedClient;
  };
  const getShopId = () => shopId || getShopIdFromLocation();

  return {
    async searchProducts(query, limit = 8) {
      const response = await getClient().prepareRequest(
        'GET',
        `${shopPath(getShopId())}/catalog/products/search`,
        { qs: { q: query, limit, region: 'all' } },
      );
      return response?.items || [];
    },

    async resolveProducts(ids) {
      const response = await getClient().prepareRequest(
        'POST',
        `${shopPath(getShopId())}/catalog/products/resolve`,
        { body: { ids, region: 'all' } },
      );
      return {
        items: response?.items || [],
        unresolved_ids: response?.unresolved_ids || [],
      };
    },
  };
}
